<script>
  import {isString,isObject,isArray,isFunction,isEqual,cloneDeepWith,clone,cloneDeep,merge,has,get,set,debounce,forOwn,findIndex} from 'lodash';
  import {transformStrByEval,createObjectByEval,transformArrayByEval,tryTransformIfEval,forOwnWithPath} from '@/utils/commonUtils'

  export default {
    name: "vue-json-layout",
    props: {
      layout:Object,
      model:Object,
      syncModelWithStorePath:String,
      initData:{
        type:Object,
        default:()=>{return {}}
      }
    },
    data () {
      return {
        loadedLayout:undefined,
        chieldIndex:-1,
        data:this.initData,
        innerModel:undefined,
        syncStoreModel:undefined,
        evaledLayout:{},
        evaledMethods:{},
        subscriptions:{}
      };
    },
    created(){
      if (this.layout.init)  transformStrByEval(this.layout.init,this.getContext());
      if (this.layout.$method){
        const evaledMethodParams = (this.layout.params||[]).map(p => createObjectByEval(p,this.getContext()));
        get(this,this.layout.$method).apply(this,evaledMethodParams).then(result=>this.init(result))
      }else{
        this.init(this.layout)
      }
    },
    destroyed(){
      forOwn(this.subscriptions,(v)=> v.unsubscribe())
    },
    methods:{
      init(loadedLayout){
        this.loadedLayout=loadedLayout;

        if (this.syncModelWithStorePath){
          const syncModelWithStorePath = transformStrByEval(this.syncModelWithStorePath, this.getContext());
          let savedInStoreModel = this.$store.getters.getUserValueByPath(syncModelWithStorePath);
          this.syncStoreModel= merge({},this.model,savedInStoreModel)
          // if (savedInStoreModel) {
          //
          // }else{//Если состояние мы еще не сохраняли
          //   this.$store.commit('setUserValue',{path:syncModelWithStorePath,value:this.model})
          // }
        }

        this.innerModel=this.loadedLayout.cloneAndUseSelfModel?cloneDeep(this.getModelWithStore()):undefined;
        if (this.innerModel) this.$watch('innerModel',(newVal,oldVal)=>{this.refreshEvaledLayout()},{deep:true});

        this.refreshEvaledLayout();

      },
      getModel(){
        return this.loadedLayout.cloneAndUseSelfModel?this.innerModel:this.getModelWithStore();
      },
      getModelWithStore(){
          return this.syncModelWithStorePath?this.syncStoreModel:this.model;
      },
      getContext(additionContext){
        return merge({"vue":this},additionContext)
      },

      getDebounceWrapper(func,timeout,options,firstImmediateCall=true){
        let debounced = debounce(func,timeout,options);
        if(firstImmediateCall){
          let isCalled = false;
          return function(...args){
            if(!isCalled){
              func(...args);
              isCalled=true;
            }else{
              debounced(...args);
            }
          }
        }else{
          return debounced;
        }
      },
      eval(evalObj,destObj,methodsParamsObj,context,self){

        forOwnWithPath(evalObj,(path,v,key,obj)=>{

          if (path.endsWith("$")){
            if (!has(destObj,path.slice(0, -1))) Vue.$nestedSet(destObj,path.slice(0, -1),v);
            return true;//прекращаем дальнейшию итерацию объекта
          }


          try {
            if (isString(v)&&v.startsWith("{") && v.endsWith("}")){
              const evaledValue = transformStrByEval(v, context);
              if (!isEqual(get(destObj, path), evaledValue)) Vue.$nestedSet(destObj, path, evaledValue);

              if (!has(destObj,path)) Vue.$nestedSet(destObj, path, undefined);//если значение не определено, то явно проставляем у него значение свойства undefined
              return;

            }

          }catch (e) {
            try {
              JSON.parse(v);
            }catch (q) {
              console.error("Error method evaledValue for path: "+path);
              console.error(e);
            }
          }

          if (isObject(v)&&v.$expression) {
            const evaledValue = transformStrByEval(v.$expression,context);

            if (!isEqual(get(destObj,path),evaledValue)) Vue.$nestedSet(destObj,path,evaledValue)
          }

          if (isObject(v)&&v.$method) {

            const evaledMethodParams = tryTransformIfEval(v.params||[],context);

            if (!has(methodsParamsObj,path+".method")) {

              const catchHandler = v.catchHandler?transformStrByEval(v.catchHandler,context):(e)=>{throw e};

              let invokeMethod = (evaledMethodParams)=>{
                get(self,v.$method).apply(self,evaledMethodParams).then(result=>{
                  if (v.transform) {
                    try {
                      result = transformStrByEval(v.transform,merge({"responce":result},context))
                    }catch (e) {
                      console.error("Error method transform for path: "+path);
                      throw e;
                    }

                  }
                  if (v.mapper) {
                    try {
                      result = result.map((e,index)=>createObjectByEval(v.mapper,merge(context,{"e":e,"elementIndex":index})))
                      //result = transformArrayByEval(result,v.mapper,context)
                    }catch (e) {
                      console.error("Error method mapper for path: "+path);
                      throw e;
                    }

                  }
                  Vue.$nestedSet(destObj,path,result)
                }).catch(catchHandler)
              };

              if (v.debounce) invokeMethod=this.getDebounceWrapper(invokeMethod,...v.debounce);

               // debounce(invokeMethod,v.debounce[0],v.debounce[1])

              Vue.$nestedSet(methodsParamsObj,path+".method",invokeMethod)

            }

            if (!isEqual(get(methodsParamsObj,path+".params"),evaledMethodParams)){
              if (!v.condition||transformStrByEval(v.condition,context)){
                Vue.$nestedSet(methodsParamsObj,path+".params",evaledMethodParams);
                //invokeMethod(evaledMethodParams)
                get(methodsParamsObj,path+".method")(evaledMethodParams);
              }
            }

            if (!has(destObj,path)) {
              Vue.$nestedSet(destObj,path,v.default?transformStrByEval(v.default,context):undefined)
            }


            if (v.stomp&&!self.subscriptions[path]){

              const updateOrDeleteEntity = (items,entity,update=true)=>{
                const entityIndex = findIndex(items,{"id":entity.id});
                if (entityIndex>-1) {
                  if (v.mapper) entity = createObjectByEval(v.mapper,merge(context,{"e":entity,"elementIndex":entityIndex}))
                  update?Vue.set(items,entityIndex,entity):items.splice(entityIndex, 1);
                  return true;
                }
                return false;
              };
/*
              let debouncedReload = debounce(function(f){
                get(methodsParamsObj,path+".method")(get(methodsParamsObj,path+".params"));
              },500);*/

              [].concat(v.stomp).forEach(i=>{
                self.$stomp.subscribe(
                  i.href,
                  i.topic,
                  (message)=>{
                    if(i.reloadOnStompMessage){
                      get(methodsParamsObj,path+".method")(get(methodsParamsObj,path+".params"));
                      //debouncedReload();
                      return;
                    }//Занова вызываем метод для обновления данных
                    let body = JSON.parse(message.body);
                    if(message.headers.destination.endsWith("created")){
                      //invokeMethod(get(methodsParamsObj,path+".params"))//Занова вызываем метод для обновления данных
                      get(methodsParamsObj,path+".method")(get(methodsParamsObj,path+".params"));//Занова вызываем метод для обновления данных
                     // debouncedReload();
                    }else if(message.headers.destination.endsWith("updated")){

                      if (!updateOrDeleteEntity(get(destObj,path),body.newEntity,true)){
                        get(destObj,path).forEach(e=>isArray(e.values)?updateOrDeleteEntity(e.values,body.newEntity,true):undefined)//Кастомная реализация для групп
                      }

                    }else if(message.headers.destination.endsWith("deleted")){

                      if (!updateOrDeleteEntity(get(destObj,path),body.entity,false)){
                        get(destObj,path).forEach(e=>isArray(e.values)?updateOrDeleteEntity(e.values,body.entity,false):undefined)
                      }

                    }else{
                      console.warn(message);
                    }
                  },
                  (subscription)=>Vue.set(self.subscriptions,path,subscription))
              });


            }

            return true;
          }

          if (!has(destObj,path)){
            ((typeof(v) == 'object')&&(v!=null))
              ?Vue.$nestedSet(destObj,path,v.constructor())
              :Vue.$nestedSet(destObj,path,v)
          }

       })
      },
      refreshLayoutParams(){
        if (!this.evaledLayout.params) Vue.set(this.evaledLayout,'params',{});
        if (!this.evaledMethods.params) Vue.set(this.evaledMethods,'params',{});

        if (!has(this.evaledLayout.params,"on.jsonLayoutChangeIndexShowChildren")){
          Vue.$nestedSet(this.evaledLayout.params,"on.jsonLayoutChangeIndexShowChildren",(e)=>{
            this.chieldIndex=e;
            //Если в первоначальных параметрах также был определен этот ообработчик, то также туда пробрасываем событие
            if (isFunction(get(this.loadedLayout.params,'on.jsonLayoutChangeIndexShowChildren'))) get(this.loadedLayout.params,'on.jsonLayoutChangeIndexShowChildren')(e)
          });
        }

        this.eval(this.loadedLayout.params,this.evaledLayout.params,this.evaledMethods.params,this.getContext(),this)

      },
      refreshLayoutData(){
        if (!this.evaledMethods.data) Vue.set(this.evaledMethods,'data',{});
        this.eval(this.loadedLayout.data,this.data,this.evaledMethods.data,this.getContext(),this)
      },

      refreshLayoutModel(){
        if (!this.evaledMethods.model) Vue.set(this.evaledMethods,'model',{});
        this.eval(this.loadedLayout.model,this.getModel(),this.evaledMethods.model,this.getContext(),this)
      },

      refreshEvaledLayout(){

        this.refreshLayoutData();
        this.refreshLayoutModel();
        this.refreshLayoutParams();


        if (!this.evaledLayout.component) Vue.set(this.evaledLayout,'component',this.loadedLayout.component);
        if (!this.evaledLayout.children) Vue.set(this.evaledLayout,'children',this.loadedLayout.children);


      }
    },
    watch:{
      syncStoreModel:{
        deep:true,
        handler(newModel){
          const syncModelWithStorePath = transformStrByEval(this.syncModelWithStorePath, this.getContext());
          this.$store.commit('setUserValue',{path:syncModelWithStorePath,value:newModel})
        }
      },
      model:{
        //immediate:true,
        deep:true,
        handler(){
          if (this.loadedLayout) this.refreshEvaledLayout();

        }
      },
      data:{
        deep:true,
        handler(){
          if (this.loadedLayout) this.refreshLayoutParams();
        }
      },
      initData:{
        //deep:true,
        handler(){
           if (this.loadedLayout) {
             for(var propName in this.initData){
               Vue.$nestedSet(this.data,propName,this.initData[propName])
             }
             //merge(this.data,this.initData)
           }
        }
      }
    },
    render(createElement) {
      const self=this;

      if (!this.loadedLayout) return;

      //TODO не работает - может вызываться у дочерних элементах у которых контекста может уже и не быть
     // if (this.loadedLayout.vIf&&!transformStrByEval(this.loadedLayout.vIf,self.getContext())) return;

      const clonedParams = clone(this.evaledLayout.params);


      if (this.loadedLayout.scopedSlots){
        clonedParams.scopedSlots={};
        forOwn(this.loadedLayout.scopedSlots,(v,slotName)=>clonedParams.scopedSlots[slotName]=props=>createElement("vue-json-layout",{
          style:v.style,
          class:v.class,
          props:{
            layout:v.layout,
            model:v.model||self.getModel(),
            initData:props,
          },
          key:v.key?transformStrByEval(v.key,self.getContext(props)):undefined
        }))
      }

      // const key = get(this,'_vnode.parent.key');
      //
      // if (key) clonedParams.key=key;

      return createElement(this.evaledLayout.component,clonedParams,
        [].concat((self.chieldIndex==-1?this.evaledLayout.children:this.evaledLayout.children[self.chieldIndex])||[])
          .reduce((prev,current)=>current?prev.concat(current):prev,[])
          .filter(e=>e)
          .filter(e=>!e.vIf||transformStrByEval(e.vIf,self.getContext()))
          .map((e,index)=>isObject(e)&&e.component
                              ?createElement("vue-json-layout",{props:{layout:e,model:self.getModel()},slot:(e.params||{}).slot,key:this.evaledLayout.children.indexOf(e)+"_"+self.chieldIndex})
                              :isString(e)
                                    ?transformStrByEval(e,self.getContext())
                                    :e
          ))


    }
  }
</script>

